






















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GDrawer',
  model: {
    prop: 'show',
    event: 'toggle',
  },
  computed: {
    isShow: {
      get(): boolean {
        return this.show;
      },
      set(val: boolean): void {
        this.$emit('toggle', val);
      },
    },
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  watch: {
    isShow(show: boolean) {
      if (show && document.body.offsetWidth < 768) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  methods: {
    onClose() {
      this.$emit('toggle', false);
    },
  },
});
